import React from 'react';
import './Footer.css';
import iconEmail from '../assets/icons/OMO-Email-Icon.svg';
import iconInstagram from '../assets/icons/OMO-Instagram-Icon (1).svg';
import iconLinkedIn from '../assets/icons/OMO-LinkedIn-Icon (1).svg';
//import iconFacebook from '../assets/icons/OMO-Facebook-Icon.svg';
import logoDots from '../assets/OMO-Logo-Emblem.svg';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-box left">
        <img src={logoDots} alt="OMO logo" className="footer-logo-inline" />
        <div className="footer-text-group">
          <a
            href="https://www.omocreative.com/privacy-policy/"
            className="footer-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
          <p className="footer-copy">© 2025 OMO Creative Agency. All Rights Reserved.</p>
        </div>
      </div>

      <div className="footer-box center">
        <p className="footer-label">Here's our email</p>
        <div className="footer-email">
          <a href="mailto:hello@omocreative.com">
            <img src={iconEmail} alt="Email" />
          </a>
          <span>hello@omocreative.com</span>
        </div>

        <div className="footer-address">
          <div>
            <strong>Singapore</strong><br />
            601 Macpherson Road,<br />
            #05-10 Grantral Complex,<br />
            Singapore 368242
          </div>
          <div>
            <strong>Malaysia</strong><br />
            F-3A-3, Encorp Strand Garden Office,<br />
            12, Jalan PJU 5/1, 47810 Petaling Jaya,<br />
            Selangor
          </div>
        </div>
      </div>

      <div className="footer-box right">
        <p className="footer-label">Social</p>
        <div className="footer-social">
          <a href="https://www.instagram.com/omocreativeagency/" target="_blank" rel="noopener noreferrer">
            <img src={iconInstagram} alt="Instagram" />
          </a>
          <a href="https://www.linkedin.com/company/omocreativeagency" target="_blank" rel="noopener noreferrer">
            <img src={iconLinkedIn} alt="LinkedIn" />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
